/* .form-check-input:checked[type=checkbox] {
    --bs-form-check-bg-image: url("/src/assets/img/check.svg") !important;
} */

.form-check-input:checked {
    background-color: #2d95a4 !important;
    border-color: #2d95a4 !important;
}

.form-check-input[type=checkbox] {
    border-radius: .25em !important;
}

.form-check-input:checked[type=checkbox] {
   --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e") !important;       
}